import type { FaireProductEntity } from "../../entity_types/product";

export const p_cva2y6pxqf: FaireProductEntity = {
  token: "p_cva2y6pxqf",
  type: "product",
  name: "Sun Star 18K Gold Plated Stainless Steel Necklace - FGS/MS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/bfc42001ed17664171de61265c1d77a6c956f5f85052df00ba93a40b9a59ecac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7df03b261d91b8c5851c123a3da1062ed6bdc497ef2f05167b9f24ae5d1496f5.jpeg",
    "https://cdn.faire.com/fastly/7da8c3431a9f51b74a4f95dae859c932dd6eefff527828c553b0846c45a0cd56.jpeg",
    "https://cdn.faire.com/fastly/267aa2f045f8236ac1efdf550072319d4f13e262c3f7bc97281324adf4c80576.jpeg",
  ],
  priceDollars: 13.46,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel ，Zircon，18K gold plated\nSize of pendant : 21mm*63mm\nLength of chain : 400mm+ 50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 26.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:23.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
